import type { ReactNode } from "react";
import { ContentContainer } from "./ContentContainer";
import { Header } from "./Header";

interface LeftPanelProps {
  children: ReactNode;
  customMarginTop?: string;
  progress?: {
    currentStep: number;
    totalSteps: number;
  };
  subtitle?: ReactNode;
  title?: ReactNode;
}

const PADDING = {
  mobile: "px-4 py-4",
  tablet: "md:px-12 md:py-8",
  desktop: "lg:px-12 lg:py-8",
};

export const LeftPanel = ({
  children,
  progress,
  title,
  subtitle,
  customMarginTop,
}: LeftPanelProps) => (
  <div
    className={[
      "animate-fade-in-slow flex w-full flex-col bg-white lg:w-[45%]",
      ...Object.values(PADDING),
    ].join(" ")}
  >
    <div className="flex flex-col">
      <Header />
      <ContentContainer
        title={title}
        subtitle={subtitle}
        progress={progress}
        customMarginTop={customMarginTop}
      >
        {children}
      </ContentContainer>
    </div>
  </div>
);
